<template>
  <div class="container-wrapper" v-loading="loading">
    <div class="breadcrumb-wrapper">资源位配置</div>

    <div class="search-wrapper">
      <el-form :inline="true" v-model="paramData">
        <el-form-item label="状态">
          <el-select placeholder="请选择状态" v-model="paramData.status">
            <el-option label="全部状态" :value="0"></el-option>
            <el-option label="已发布" :value="2"></el-option>
            <el-option label="未发布" :value="1"></el-option>
            <el-option label="已撤销" :value="9"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="位置类型">
          <el-select
            placeholder="请选择位置类型"
            v-model="paramData.positionType"
          >
            <el-option label="全部位置" :value="0"></el-option>
            <el-option label="进展banner" :value="9"></el-option>
            <el-option label="首页活动信息栏" :value="13"></el-option>
            <el-option label="首页宣传栏" :value="14"></el-option>
            <el-option label="我的banner" :value="15"></el-option>
            <el-option label="排行榜banner" :value="19"></el-option>
            <el-option label="支付宝小程序首页banner" :value="21"></el-option>
            <el-option label="支付宝小程序我的banner" :value="22"></el-option>
            <el-option label="广场推荐banner" :value="23"></el-option>
            <el-option label="3.0.0版本之前的发现频道" :value="1"></el-option>
            <el-option label="跑步结束banner" :value="2"></el-option>
            <el-option label="运动音乐顶部" :value="3"></el-option>
            <el-option label="首页-为你推荐" :value="4"></el-option>
            <el-option label="社区-动态" :value="5"></el-option>
            <el-option label="3.0.0版本及之后的发现频道" :value="6"></el-option>
            <el-option label="问卷调查" :value="7"></el-option>
            <el-option label="运动banner" :value="8"></el-option>
            <el-option label="首页瓷片1" :value="10"></el-option>
            <el-option label="首页瓷片2" :value="11"></el-option>
            <el-option label="首页瓷片3" :value="12"></el-option>
            <el-option label="首页摩西" :value="20"></el-option>
            <el-option label="小程序顶部banner轮播" :value="16"></el-option>
            <el-option label="小程序banner" :value="17"></el-option>
            <el-option label="小程序底部banner列表" :value="18"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="daterange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="名称">
          <el-input
            placeholder="搜索名称关键字"
            v-model="paramData.keyWord"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="queryList">搜索</el-button>
      <el-button @click="clickReset">重置</el-button>
    </div>

    <div class="action-wrapper">
      <el-button type="primary" @click="clickAddition">新增</el-button>
      <el-button type="primary" @click="clickBatchPublish">批量发布</el-button>
      <el-button @click="clickBatchRevoke">批量撤销</el-button>
      <el-button @click="clickBatchDelete">批量删除</el-button>
    </div>

    <div class="content-wrapper">
      <el-table :data="listData" @selection-change="selectionChanged">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column align="center" label="ID" prop="id"></el-table-column>
        <el-table-column align="center" label="类型">
          <template scope="{ row }">
            <div v-if="row.positionType === 9">进展BANNER</div>
            <div v-if="row.positionType === 13">首页活动信息栏</div>
            <div v-if="row.positionType === 14">首页宣传栏</div>
            <div v-if="row.positionType === 15">我的-轮播位</div>

            <div v-if="row.positionType === 19">排行榜banner</div>
            <div v-if="row.positionType === 21">支付宝小程序首页banner</div>
            <div v-if="row.positionType === 22">支付宝小程序我的banner</div>
            <div v-if="row.positionType === 23">社区推荐页顶部</div>
            <div v-if="row.positionType === 1">3.0.0版本之前的发现频道</div>
            <div v-if="row.positionType === 2">跑步记录顶部</div>
            <div v-if="row.positionType === 3">运动音乐顶部</div>
            <div v-if="row.positionType === 4">首页-为你推荐</div>
            <div v-if="row.positionType === 5">社区-动态</div>
            <div v-if="row.positionType === 6">3.0.0版本及之后的发现频道</div>
            <div v-if="row.positionType === 7">问卷调查</div>
            <div v-if="row.positionType === 8">运动banner</div>
            <div v-if="row.positionType === 10">首页瓷片1</div>
            <div v-if="row.positionType === 11">首页瓷片2</div>
            <div v-if="row.positionType === 12">首页瓷片3</div>
            <div v-if="row.positionType === 20">首页摩西</div>
            <div v-if="row.positionType === 16">小程序顶部banner轮播</div>
            <div v-if="row.positionType === 17">小程序banner</div>
            <div v-if="row.positionType === 18">小程序底部banner列表</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="名称"
          prop="title"
        ></el-table-column>
        <el-table-column align="center" label="图形" min-width="160">
          <template scope="{ row }">
            <div class="flex-row-center margin-bottom-10">
              <img class="table-img" :src="row.imgUrl" alt="" />
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="适用学校">
          <template scope="{ row }">
            <div>{{ row.applicableCampus ? "部分" : "全部" }}</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="点击量"
          prop="clickCount"
        ></el-table-column>
        <!-- <el-table-column align="center" label="有效时间" width="180">
          <template scope="{ row }">
            <div>{{ row.publisher }}</div>
            <div v-if="row.publishTime">
              {{ new Date(row.publishTime).format("yyyy-MM-dd hh:mm:ss") }}
            </div>
          </template>
        </el-table-column> -->
        <el-table-column align="center" label="状态">
          <template scope="{ row }">
            <div v-if="row.status === 1">草稿</div>
            <div v-if="row.status === 2">发布</div>
            <div v-if="row.status === 9">撤销发布</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="有效时间" width="320">
          <template scope="{ row }">
            <div v-if="row.beginAt && row.endAt">
              {{ new Date(row.beginAt).format("yyyy-MM-dd hh:mm:ss") }} -
              {{ new Date(row.endAt).format("yyyy-MM-dd hh:mm:ss") }}
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="最近操作时间" width="200">
          <template scope="{ row }">
            <div v-if="row.updatedTime">
              {{ new Date(row.updatedTime).format("yyyy-MM-dd hh:mm:ss") }}
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="创建时间" width="200">
          <template scope="{ row }">
            <div>{{ row.creater }}</div>
            <div>
              {{ new Date(row.createTime).format("yyyy-MM-dd hh:mm:ss") }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="180" fixed="right">
          <template scope="{ row }">
            <div v-if="[1, 9].includes(row.status)">
              <el-button type="text" @click="clickPublish(row)">发布</el-button>
              <el-button type="text" @click="clickEdit(row)">编辑</el-button>
              <el-button
                type="text"
                style="color: red"
                @click="clickDelete(row)"
                >删除</el-button
              >
            </div>
            <div v-else>
              <el-button type="text" @click="clickDetail(row)">详情</el-button>
              <el-button
                type="text"
                style="color: red"
                @click="clickRevoke(row)"
                >撤销</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrapper">
      <el-pagination
        v-show="total > 0"
        layout="prev, pager, next"
        :current-page="paramData.pageNum"
        :page-size="paramData.pageSize"
        :total="total"
        @current-change="changeCurrentPage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      paramData: {
        status: 0, //  0-全部； 1-草稿； 2-发布 9-撤销发布
        positionType: 0,
        beginAt: "",
        endAt: "",
        keyWord: "",
        pageNum: 1,
        pageSize: 10,
      },
      daterange: [],
      total: 0,
      listData: [],
      multipleSelection: [],
    };
  },

  mounted() {
    this.queryList();
  },

  methods: {
    // 查询列表
    queryList() {
      if (this.daterange.length) {
        this.paramData.beginAt = new Date(this.daterange[0] || "").getTime();
        this.paramData.endAt = new Date(this.daterange[1] || "").getTime();
      }
      this.loading = true;

      this.$http({
        url: this.$util.domain + "/adminapi/v3/operate/banner/list",
        method: "POST",
        body: JSON.stringify(this.paramData),
      })
        .then((res) => {
          this.total = res.data.data.totalCount || 0;
          this.listData = res.data.data.list || [];
        })
        .catch((err) => {
          this.total = 0;
          this.listData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 更新状态（发布或撤销）
    updateStatus(params) {
      let message =
        "确定要发布吗？发布后该篇会变成“已发布”状态，且用户端将会看到该篇内容";
      let title = "发布";
      if (params.newStatus === 9) {
        message =
          "确定要撤销发布吗？撤销发布后该篇会变成“已撤销”状态，且用户端将无法看到该篇内容";
        title = "撤销";
      }
      this.$confirm(message, title, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$http({
            url:
              this.$util.domain + "/adminapi/v3/operate/banner/change_status",
            method: "POST",
            body: JSON.stringify({ ...params }),
          })
            .then((res) => {
              if (res.body.error === 10000) {
                this.queryList();
              } else {
                this.$util.errorMsg(res.body.message || "请联系管理员");
              }
            })
            .catch((err) => {
              this.$util.errorMsg(err.message);
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    // 发送删除
    sendDelete(params) {
      this.$confirm("确定要删除吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$http({
            url: this.$util.domain + "/adminapi/v3/operate/banner/delete",
            method: "POST",
            body: JSON.stringify({ ...params }),
          })
            .then((res) => {
              if (res.body.error === 10000) {
                this.queryList();
              } else {
                this.$util.errorMsg(res.body.message || "请联系管理员");
              }
            })
            .catch((err) => {
              this.$util.errorMsg(err.message);
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    // 点击重置
    clickReset() {
      this.paramData = {
        status: 0,
        positionType: 0,
        beginAt: "",
        endAt: "",
        keyWord: "",
        pageNum: 1,
        pageSize: 10,
      };
      this.daterange = [];
      this.queryList();
    },
    // 点击新增按钮
    clickAddition() {
      this.$router.push({
        path: "/yunying/advertising/resource/detail",
        query: { positionType: this.paramData.positionType, actionType: "add" },
      });
    },
    // 点击批量发布
    clickBatchPublish() {
      const ids = this.multipleSelection
        .filter((item) => {
          return [1, 9].includes(item.status);
        })
        .map((item) => item.id);
      if (ids && ids.length) {
        const params = {
          ids,
          newStatus: 2,
        };
        this.updateStatus(params);
      } else {
        this.$util.errorMsg("请选择数据后操作");
      }
    },
    // 点击批量撤销
    clickBatchRevoke() {
      const ids = this.multipleSelection
        .filter((item) => {
          return ![1, 9].includes(item.status);
        })
        .map((item) => item.id);
      if (ids && ids.length) {
        const params = {
          ids,
          newStatus: 9,
        };
        this.updateStatus(params);
      } else {
        this.$util.errorMsg("请选择数据后操作");
      }
    },
    // 点击批量删除
    clickBatchDelete() {
      const ids = this.multipleSelection
        .filter((item) => {
          return [1, 9].includes(item.status);
        })
        .map((item) => item.id);
      if (ids && ids.length) {
        const params = { ids };
        this.sendDelete(params);
      } else {
        this.$util.errorMsg("请选择数据后操作");
      }
    },
    // 单元格选中
    selectionChanged(val) {
      this.multipleSelection = val;
    },
    // 点击详情
    clickDetail(row) {
      this.$router.push({
        path: "/yunying/advertising/resource/detail",
        query: {
          positionType: row.positionType,
          actionType: "detail",
          id: row.id,
        },
      });
    },
    // 点击编辑
    clickEdit(row) {
      this.$router.push({
        path: "/yunying/advertising/resource/detail",
        query: {
          positionType: row.positionType,
          actionType: "edit",
          id: row.id,
        },
      });
    },
    // 点击发布
    clickPublish(row) {
      const params = {
        id: row.id,
        newStatus: 2,
      };
      this.updateStatus(params);
    },
    // 点击撤销
    clickRevoke(row) {
      const params = {
        id: row.id,
        newStatus: 9,
      };
      this.updateStatus(params);
    },
    // 点击删除
    clickDelete(row) {
      const params = {
        id: row.id,
      };
      this.sendDelete(params);
    },
    // 切换当前页码
    changeCurrentPage(val) {
      this.paramData.pageNum = val;
      this.queryList();
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// ResourceSpace.vue?fd470c50